import I18n from '../../../lib/i18n';

export const getTranslations = () => ({
  components: {
    error_message_retry_backdrop: {
      retry: I18n.t('refresh'),
    },
    importantNotice: I18n.t('importantNotice'),
    taxFootnote: {
      exclusiveDescription: I18n.t('tax.exclusiveDescription'),
      inclusiveDescription: I18n.t('tax.inclusiveDescription'),
    },
  },
  errors: {
    modal: {
      message: I18n.t('error.modal.message'),
      title: I18n.t('error.modal.title'),
    },
    webError: I18n.t('error.webError'),
  },
});
